<template>
  <div class="comment-content">
    <div class="top" v-if="total">{{ total }}条评论</div>
    <div class="comment-list">
      <div class="comment-item" v-for="(item, index) in data" :key="index">
        <div class="item-avatar">
          <van-image class="avatar" :src="item.head_img" fit="cover" />
          <img
            class="flag"
            v-if="item.label_data && item.label_data.length"
            :src="item.label_data[0].icon"
            alt=""
          />
        </div>
        <div class="item-right">
          <div class="item-top">
            <div class="item-center">
              <div class="item-nickname">{{ item.truename }}</div>
              <!--  <div class="desc">{{ item.label_data | filterDesc }}</div> -->
            </div>
            <!-- <div class="like">
                            <span class="iconfont icon-a-dianliang3x"></span><span>{{ item.zan_num }}</span>
                        </div> -->
          </div>
          <div class="item-words">{{ item.comment }}</div>
          <div class="item-time"
            >{{ item.addtime | filterCommentTime
            }}<span class="item-time-reply"> 回复</span></div
          >
          <!-- 子评论 -->
          <div
            class="item-children"
            v-if="item.comment_list && item.comment_list.length"
          >
            <div
              class="child-item"
              v-for="(item1, index1) in item.open
                ? item.comment_list
                : item.realCommentList"
              :key="index1"
            >
              <div class="c-left">
                <div class="c-l-top">
                  <img class="c-l-top-avatar" :src="item1.head_img" alt="" />
                  <div>
                    <span>{{ item1.truename }}</span>
                    <span v-if="item1.t_unify_id != item.unify_id">
                      <span class="reply">回复</span>
                      <span>{{ item1.t_truename }}</span></span
                    >
                  </div>
                </div>
                <div class="c-words">{{ item1.comment }}</div>
                <div class="c-time"
                  ><span>{{ item1.addtime | filterCommentTime }}</span
                  ><span class="item-time-reply"> 回复</span></div
                >
              </div>
              <!-- <div class="c-right">
                                <div class="iconfont icon-a-dianliang3x"></div>
                                <div>{{ item1.zan_num }}</div>
                            </div> -->
            </div>
            <div
              class="show-more"
              v-if="item.showMore && !item.open"
              @click="item.open = true"
              >查看全部{{ item.comment_list.length }}条回复</div
            >
          </div>
        </div>
      </div>
    </div>
    <div class="not-more" v-if="finished && total"
      >没有更多评论了,快发布一条吧...</div
    >
    <div class="not-data" v-if="finished && !total">
      <img
        class="not-data-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d3be9ea8aa66beb90fd4d31cda0a6a9f.png"
        alt=""
      />
      <div class="not-data-text">快来发表你的评论吧</div>
    </div>
  </div>
</template>
<script>
import dataObj from '@/common/date.js'
export default {
  props: {
    finished: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number | String,
      default: 0
    }
  },
  filters: {
    filterDesc(labels) {
      if (!labels.length) {
        return ''
      }
      return (labels[0] && labels[0].alias) || ''
    },
    filterCommentTime(time) {
      let commentTime = new Date(time.replace(/-/g, '/'))
      let res = dataObj.handleCommentDate(commentTime)
      return res
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.comment-content {
  background: #fff;
  padding: 20px;

  .top {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #050b27;
    line-height: 22px;
    margin-bottom: 23px;
  }

  .comment-list {
    .comment-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 24px;

      .item-avatar {
        width: 36px;
        height: 36px;
        margin-right: 16px;
        position: relative;
        .avatar {
          width: 36px;
          height: 36px;
          overflow: hidden;
          border-radius: 50%;
        }
        .flag {
          height: 15px;
          position: absolute;
          bottom: 0;
          right: 0;
          transform: translate(20%, 0%);
        }
      }

      .item-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .item-top {
          display: flex;
          align-items: center;
          margin-bottom: 4px;

          .item-center {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;

            .item-nickname {
              font-family: PingFangSC;
              font-weight: 400;
              font-size: 14px;
              color: rgba(5, 11, 39, 0.5);
              line-height: 20px;
            }

            .desc {
              font-size: 10px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: rgba(0, 0, 0, 0.6);
              line-height: 14px;
            }
          }

          .like {
            font-size: 10px;
            font-family: PingFang SC;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.3);
            line-height: 14px;
            display: flex;
            align-items: center;

            .iconfont {
              margin-right: 8px;
              color: rgb(221, 221, 221);
            }
          }
        }

        .item-words {
          font-weight: 400;
          font-size: 14px;
          color: #050b27;
          line-height: 20px;
          margin-bottom: 4px;
          word-break: break-all;
          white-space: pre-wrap;
        }

        .item-time {
          font-size: 12px;
          color: rgba(5, 11, 39, 0.3);
          line-height: 17px;
        }
        .item-time-reply {
          margin-left: 10px;
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 12px;
          color: rgba(5, 11, 39, 0.5);
          line-height: 17px;
        }
        .item-children {
          margin-top: 12px;
          .child-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 12px;

            .c-left {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;

              .c-l-top {
                margin-bottom: 4px;
                font-size: 12px;
                font-family: PingFang SC;
                font-size: 14px;
                color: rgba(5, 11, 39, 0.5);
                line-height: 20px;
                display: flex;
                align-items: center;
                .c-l-top-avatar {
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  overflow: hidden;
                  margin-right: 6px;
                }
                .reply {
                  font-weight: 400;
                  margin-left: 4px;
                  margin-right: 4px;
                }
              }

              .c-words {
                font-size: 14px;
                color: #050b27;
                line-height: 20px;
                margin-bottom: 4px;
                word-break: break-all;
                white-space: pre-wrap;
              }

              .c-time {
                font-size: 12px;
                color: rgba(5, 11, 39, 0.3);
                line-height: 17px;
              }
            }

            .c-right {
              text-align: center;
              font-size: 10px;
              font-family: PingFang SC;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.3);
              line-height: 14px;

              .iconfont {
                margin-bottom: 2px;
                color: rgb(221, 221, 221);
              }
            }
          }

          .child-item:last-child {
            margin-bottom: 0px;
          }

          .show-more {
            margin-top: 12px;
            font-weight: bold;
            font-size: 12px;
            color: #4d58a1;
            line-height: 17px;
          }
        }
      }
    }
  }
  .not-more {
    text-align: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
  }
  .not-data {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .not-data-image {
      width: 138px;
      margin-bottom: 10px;
    }
    .not-data-text {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
